<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<!-- Material Look-n-Feel -->
<div class="tiny-ticket-wrapper wrap-relative ext-sched-id-container">
	<mat-form-field class="full-width" subscriptSizing="dynamic">
		<mat-label>{{ appStrings.FILTER_BY_EXTERNAL_SCHEDULE_ID }}</mat-label>
		<input
			matInput
			class="ext-sched-id-input"
			(focus)="internalFocused()"
			(blur)="internalBlurred()"
			[formControl]="internalField"
		/>
	</mat-form-field>
</div>
